import Text from '@do/walrus/Text';
import colors from '@do/walrus/scss/core/_colors.scss';
import vars from '@do/walrus/scss/core/_variables.scss';
import _get from 'lodash/get';
import * as React from 'react';
import styled from 'styled-components';
import { METADATA_HEIGHT } from '../constants';
import { GetRegistrationInfo } from '../generated-types/GetRegistrationInfo';
import { Variant } from '../interfaces/registration';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-right: ${vars.whitespace_xsmall};
  border: ${vars.border_width_thin} solid ${colors.grey_light};
  margin: ${vars.whitespace_regular} 0;
  border-radius: ${vars.border_radius};
`;

const IconCol = styled.div`
  height: ${METADATA_HEIGHT}px; /* Square column */
  width: ${METADATA_HEIGHT}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  width: ${METADATA_HEIGHT * 0.6}px;
`;

const DataCol = styled.div`
  padding: ${vars.whitespace_small} ${vars.whitespace_small}
    ${vars.whitespace_small} 0;
  flex: 1;
`;

const Title = styled(Text)`
  font-weight: bold;
  margin-bottom: ${vars.whitespace_xsmall};
`;

const Description = styled(Text)`
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
`;

const Metadata: React.FC<{
  data?: GetRegistrationInfo;
  variant: Variant;
}> = ({ data, variant }) => {
  return (
    <Container>
      <IconCol>
        <Icon src={_get(data, 'registrationFormData.marketplace_app.icon')} />
      </IconCol>
      <DataCol>
        <Title>{variant.metadata && variant.metadata.title}</Title>
        <Description>
          {variant.metadata && variant.metadata.description}
        </Description>
      </DataCol>
    </Container>
  );
};

export default Metadata;
